import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">İletişim Bilgileri</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-map-pin-line text-teal-400"></i>
                </div>
                <span className="text-gray-300">Sancak, Serincan Sk. No:23 D:N, 42250 Selçuklu/Konya</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line text-teal-400"></i>
                </div>
                <span className="text-gray-300">+90 532 376 05 85</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-teal-400"></i>
                </div>
                <span className="text-gray-300">bilgi@ozgurisg.net</span>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-xl font-bold mb-4">Hizmetlerimiz</h3>
            <ul className="space-y-2 text-gray-300">
              <li>Risk Değerlendirmesi</li>
              <li>İSG Eğitimleri</li>
              <li>Sağlık Gözetimi</li>
              <li>Acil Durum Planı</li>
              <li>İSG Danışmanlığı</li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-4">Hızlı Linkler</h3>
            <ul className="space-y-2 text-gray-300">
              <li><a href="/" className="hover:text-teal-400 transition-colors cursor-pointer">Ana Sayfa</a></li>
              <li><a href="/hizmetler" className="hover:text-teal-400 transition-colors cursor-pointer">Hizmetlerimiz</a></li>
              <li><a href="/hakkimizda" className="hover:text-teal-400 transition-colors cursor-pointer">Hakkımızda</a></li>
              <li><a href="/iletisim" className="hover:text-teal-400 transition-colors cursor-pointer">İletişim</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-gray-400">
            © 2025-2026 Özgür OSGB. Tüm hakları saklıdır. | 
            <a href="https://readdy.ai/?origin=logo" className="text-teal-400 hover:text-teal-300 ml-1 cursor-pointer">
              Özgür Group İş Sağlığı ve Güvenliği Eğitm Dan. Müh. Ltd. Şti
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};
